import { useTheme } from "./useTheme.ts";

/**
 * Header sun/moon toggle. Shows the icon for the theme you'd switch TO,
 * matching the convention used in most editors/browsers.
 */
export function ThemeToggle() {
  const { resolved, toggle } = useTheme();
  const next = resolved === "dark" ? "light" : "dark";
  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={toggle}
      aria-label={`Switch to ${next} mode`}
      title={`Switch to ${next} mode`}
      data-theme-resolved={resolved}
    >
      {resolved === "dark" ? (
        // sun icon — shown in dark mode, click → light
        <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
          <circle cx="10" cy="10" r="3.4" stroke="currentColor" strokeWidth="1.6" />
          <g stroke="currentColor" strokeWidth="1.6" strokeLinecap="round">
            <line x1="10" y1="1.5" x2="10" y2="3.5" />
            <line x1="10" y1="16.5" x2="10" y2="18.5" />
            <line x1="1.5" y1="10" x2="3.5" y2="10" />
            <line x1="16.5" y1="10" x2="18.5" y2="10" />
            <line x1="3.8" y1="3.8" x2="5.2" y2="5.2" />
            <line x1="14.8" y1="14.8" x2="16.2" y2="16.2" />
            <line x1="3.8" y1="16.2" x2="5.2" y2="14.8" />
            <line x1="14.8" y1="5.2" x2="16.2" y2="3.8" />
          </g>
        </svg>
      ) : (
        // moon icon — shown in light mode, click → dark
        <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
          <path
            d="M15.5 12.5A6.5 6.5 0 0 1 7.5 4.5a6 6 0 0 0-1.5 0 7.5 7.5 0 1 0 9.5 9.5 6 6 0 0 0 0-1.5Z"
            fill="currentColor"
          />
        </svg>
      )}
    </button>
  );
}
